import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FORTRESS_CONFIG, NO_PERMISSION_ROUTE, PermissionGuards } from '@psu-pennstateit-swe/apis/fortress';

export const hasPermissionGuard =
  (permissions: string | string[]) => (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    PermissionGuards.canActivate(
      permissions,
      false,
      NO_PERMISSION_ROUTE,
      inject(FORTRESS_CONFIG).activatedRoles,
    )(route, state);

export enum FortressPermissions {
  CanViewRoles = 'fortress-service.role.read',
}
